'use-client';
import DisqusComments from '../../DisqusComments';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';
import style from '../../style/DisqusComments.scss';

export default WithConsentPolicy(DisqusComments, {
  rootClassName: style.root,
  componentConsentPolicy: { analytics: true },
});
